var swiper = new Swiper(".mySwiper", {
     slidesPerView: 3,
     spaceBetween: 30,
     navigation: {
          nextEl: ".button-next",
          prevEl: ".button-prev",
     },
     breakpoints: {
          // when window width is >= 320px
          320: {
               slidesPerView: 1,
               spaceBetween: 20,
               autoHeight: true,
          },
          // when window width is >= 480px
          767: {
               slidesPerView: 2,
               spaceBetween: 30
          },
          // when window width is >= 640px
          1199: {
               slidesPerView: 3,
               spaceBetween: 30,
          }
     }
});

document.querySelectorAll('.accordion-button').forEach(button => {
     button.addEventListener('click', function () {
          // Remove class from all accordion items
          document.querySelectorAll('.accordion-item').forEach(item => {
               item.classList.remove('active-item');
          });

          // Add class to the clicked accordion item
          this.closest('.accordion-item').classList.add('active-item');
     });
});


var swiper = new Swiper(".mySwiper2", {
     pagination: {
          el: ".pagination1", clickable: true,
     },
     navigation: {
          nextEl: ".button-next2",
          prevEl: ".button-prev2",
     },
});

var swiper4 = new Swiper(".mySwiper4", {
     slidesPerView: 1,
     spaceBetween: 30,
     navigation: {
          nextEl: ".button-next4",
          prevEl: ".button-prev4",
     },
     pagination: {
          el: ".pagination-hero-testi",
          clickable: true,
     },
});

document.querySelectorAll('.testimonial-text-wrapper').forEach(function(wrapper) {
     var text = wrapper.querySelector('.testimonial-text');
     var link = wrapper.querySelector('.read-more-link');
     if (text.scrollHeight <= text.clientHeight) {
          link.style.display = 'none';
     }
     link.addEventListener('click', function(e) {
          e.preventDefault();
          text.classList.toggle('expanded');
          link.textContent = text.classList.contains('expanded') ? 'Read Less' : 'Read More';
     });
});

var swiper = new Swiper(".mySwiper3", {
     slidesPerView: 3,
     spaceBetween: 20,
     breakpoints: {
          // when window width is >= 320px
          320: {
               slidesPerView: 1,
               spaceBetween: 20,
          },
          576: {
               slidesPerView: 1,
               spaceBetween: 20,
          },
          // when window width is >= 480px
          767: {
               slidesPerView: 3,
               spaceBetween: 30
          },
     },
     pagination: {
          el: ".pagination2", clickable: true,
     },
});
